<div class="mt-2">
  @if (loading()) {
    <div class="items-center flex justify-center h-64">
      <soft-loading-spinner></soft-loading-spinner>
    </div>
  } @else if ((all() ?? []).length === 0) {
    <div class="items-center flex justify-center h-64">
      <p class="text-light italic text-sm">
        Keine Arbeitsbericht für diesen Tag gefunden...
      </p>
    </div>
  } @else {
    <soft-dynamic-list
      [definition]="$any(definition())"
      [items]="all() ?? []"
      (itemClick)="selectedChange.emit($event)"
      >
    </soft-dynamic-list>

    @if (totalTime(); as totalTime) {
      <div class="mb-4">
        <hr class="mt-3 mb-2" />
        @for (entry of totalTime; track entry; let first = $first) {
          <div
            class="flex flex-row justify-between items-center flex-nowrap"
            [ngClass]="first ? 'mt-3' : 'mt-2'"
            >
            <strong class="ml-1">{{ entry?.zbewe?.bezeichnung ?? 'Gesamt' }}</strong>
            <strong>{{ $safeNavigationMigration(entry?.duration) | format: 'DURATION.DEFAULT' }}</strong>
          </div>
        }
      </div>
    }
  }
</div>
